<div *ngIf="laurel() as laurel" class="movie-laurel-item">
  <img
    *ngIf="laurel.festivalLogo"
    class="logo"
    height="80"
    width="150"
    style="height: auto"
    [loaderParams]="{ fillColor: 'transparent', fit: 'contain' }"
    [ngSrc]="laurel.festivalLogo"
    [alt]="laurel.festivalName"
  />
  <div *ngIf="!laurel.festivalLogo" class="movie-laurel-name-section">
    <img [ngSrc]="leftLaurelSrc" height="80" width="38" alt="left laurel" class="left-laurel" style="height: auto" />
    <div class="movie-laurel-festival-name">{{ laurel.festivalName }}</div>
    <img [ngSrc]="rightLaurelSrc" height="80" width="38" alt="right laurel" class="right-laurel" style="height: auto" />
  </div>
  <div class="movie-laurel-desc">
    <span class="movie-laurel-festival-edition">{{ laurel.festivalEdition }}</span>
    <span class="movie-laurel-award-name">{{ laurel.awardName }}</span>
  </div>
</div>
